"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const ModelCommon_1 = require("./ModelCommon");
const debug = !process.env.AWS_SESSION_TOKEN && false;
const typeName = 'Alert';
class Alert extends ModelCommon_1.ModelCommon {
    //currently can't inhertit from Thing as constructor just expects ob. A consequence of 'can't user prototype.constructor.name in Webpack'
    // thing?: Horse;
    // shadow?: ThingShadowState;
    // timestamp?: string
    // summary?: string;
    // alerts?: { [k:string]: any};
    // decisionState?: { [k:string]: any};
    // _state?: string
    constructor(ob) {
        super(typeName, ob);
    }
    get alertStatus() {
        return {
            NOT_SET: 'NOT_SET',
            NO_ALERT: 'NO_ALERT',
            ISSUED_NO_ACK: 'ISSUED_PENDING_ACKNOWLDGED',
            ISSUED_ACKNOWLEDGED: 'ISSUED_ACKNOWLEDGED',
            RESOLVED: 'RESOLVED',
            CANCELLED: 'CANCELLED',
        };
    }
    getAlertStatusKey(keyIn) {
        const keys = Object.keys(this.alertStatus);
        return keys.find((key) => keyIn === this.alertStatus[key]);
    }
    get state() {
        return this._state;
    }
    set state(newState) {
        console.log('In setter for state on Alert');
        if (newState && Object.keys(this.alertStatus).includes(newState)) {
            this._state = newState;
        }
        else {
            console.log(`${newState} is not valide on Alert ${this.name}`);
        }
    }
    getUserAttributes() {
        const statusLabel = 'Alert Status';
        let atts = {
            description: undefined,
            ...super.getUserAttributes(),
            name: {
                //override validation
                type: 'String',
            },
            summary: {
                type: 'String',
            },
            timestamp: {
                type: 'Date',
                displayFn: (timestamp) => new Date(timestamp * 1000).toString(),
            },
            state: {
                type: 'Derived',
                valueFn: (state, functions, accessKey) => {
                    debug && console.log('Alert Status  gets', { functions, accessKey });
                    return {
                        currentValue: this.state,
                        possibleValues: this.alertStatus,
                        setValue: (e) => this.handleAlertStatusChange(functions, e, accessKey),
                        accessKey,
                        label: statusLabel,
                    };
                },
                viewName: 'EnumSelect',
            },
        };
        delete atts.description;
        return atts;
    }
    getLinkAttributes() {
        return this.getUserAttributes();
    }
}
exports.Alert = Alert;
